var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background white" },
    [
      _c(
        "v-row",
        { staticClass: "px-16 pt-6", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("img", {
                        staticClass: "arrow px-4 py-3",
                        attrs: { src: _vm.ic_back, id: "back-btn" },
                        on: { click: _vm.backTo },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ml-n4", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "back-lbl" }, [
                        _vm._v("Back to Client-Carrier EDI Tracking "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "px-16 mb-16 mt-n10", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { staticClass: "mx-4 mt-5", attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c("v-col", { staticClass: "pl-0", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "page-header" }, [
                      _vm._v(_vm._s(_vm.pageHeader)),
                    ]),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "pl-0 mt-n5", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "page-sub-header" }, [
                        _vm._v(
                          "Configure EDI tracking by selecting one client with multiple carriers."
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-6" },
                [
                  _c("v-col", { staticClass: "pl-0", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "pro-section-lbl" }, [
                      _vm._v("Enter the sender ID"),
                    ]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0 mt-n2",
                      attrs: {
                        xl: "4",
                        lg: "4",
                        md: "6",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c("smart-text-field", {
                        attrs: { required: true, placeholder: "Sender ID" },
                        model: {
                          value: _vm.senderId,
                          callback: function ($$v) {
                            _vm.senderId = $$v
                          },
                          expression: "senderId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-6" },
                [
                  _c("v-col", { staticClass: "pl-0", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "pro-section-lbl" }, [
                      _vm._v("Enter the receiver ID"),
                    ]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0 mt-n2",
                      attrs: {
                        xl: "4",
                        lg: "4",
                        md: "6",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c("smart-text-field", {
                        attrs: {
                          label: "Receiver ID",
                          required: true,
                          placeholder: "Receiver ID",
                        },
                        model: {
                          value: _vm.receiverId,
                          callback: function ($$v) {
                            _vm.receiverId = $$v
                          },
                          expression: "receiverId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-6" },
                [
                  _c("v-col", { staticClass: "pl-0", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "pro-section-lbl" }, [
                      _vm._v("Select the client"),
                    ]),
                    _c("label", { staticClass: "red-color" }, [_vm._v("*")]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0 mt-n2",
                      attrs: {
                        xl: "4",
                        lg: "4",
                        md: "6",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c("smart-combobox", {
                        attrs: {
                          items: _vm.accountsDdl,
                          label: "Client Name",
                          clearable: "",
                        },
                        model: {
                          value: _vm.selectedAccount,
                          callback: function ($$v) {
                            _vm.selectedAccount = $$v
                          },
                          expression: "selectedAccount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-6" },
                [
                  _c("v-col", { staticClass: "pl-0", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "pro-section-lbl" }, [
                      _vm._v("Select the carrier"),
                    ]),
                    _c("label", { staticClass: "red-color" }, [_vm._v("*")]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0 mt-n2",
                      attrs: {
                        xl: "4",
                        lg: "4",
                        md: "6",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c("smart-combobox", {
                        attrs: {
                          items: _vm.carriersDdl,
                          label: "Carrier Name",
                          "item-value": "id",
                          "item-text": "name",
                          clearable: "",
                        },
                        model: {
                          value: _vm.selectedCarrier,
                          callback: function ($$v) {
                            _vm.selectedCarrier = $$v
                          },
                          expression: "selectedCarrier",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c("v-col", { staticClass: "pl-0", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "pro-section-lbl" }, [
                      _vm._v(
                        "Determine the tracking exchanges that will occur between parties. Check to subscribe or uncheck to unsubscribe."
                      ),
                    ]),
                    _c("label", { staticClass: "red-color" }, [_vm._v("*")]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0 mt-n2",
                      attrs: {
                        xl: "8",
                        lg: "10",
                        md: "12",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        { staticClass: "br-8", attrs: { elevation: "1" } },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("v-data-table", {
                                key: _vm.gridIndex,
                                attrs: {
                                  id: "users-grid",
                                  headers: _vm.ediTypesHeaders,
                                  items: _vm.ediTypes,
                                  "hide-default-footer": true,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.id",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c("v-checkbox", {
                                          staticClass: "mt-0 smart-checkbox",
                                          attrs: {
                                            ripple: false,
                                            "hide-details": true,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onEdiTypeSelect(item)
                                            },
                                          },
                                          model: {
                                            value: item.selected,
                                            callback: function ($$v) {
                                              _vm.$set(item, "selected", $$v)
                                            },
                                            expression: "item.selected",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-col", { attrs: { cols: "12" } }),
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0",
                      attrs: {
                        xl: "4",
                        lg: "4",
                        md: "6",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c("smart-calendar", {
                        attrs: {
                          "offset-x": true,
                          required: true,
                          label: "Effective Date",
                        },
                        model: {
                          value: _vm.effectiveDate,
                          callback: function ($$v) {
                            _vm.effectiveDate = $$v
                          },
                          expression: "effectiveDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-col", { staticClass: "mt-n2", attrs: { cols: "12" } }),
                  _c(
                    "v-col",
                    {
                      staticClass: "pr-0 mt-n16",
                      attrs: {
                        xl: "8",
                        lg: "10",
                        md: "12",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "mt-10" },
                        [
                          _c("v-spacer"),
                          _c(
                            "v-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c("smart-btn", {
                                attrs: {
                                  label: "Cancel",
                                  bg: "white",
                                  border: "navy-blue",
                                  font: "navy-blue",
                                },
                                on: { click: _vm.backTo },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c("smart-btn", {
                                class: { "w-100-pct": _vm.smAndDown },
                                attrs: { label: "Save", type: "primary" },
                                on: { click: _vm.showConfirm },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v(_vm._s(_vm.loadingMessage)),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "546px" },
          model: {
            value: _vm.displayPopup,
            callback: function ($$v) {
              _vm.displayPopup = $$v
            },
            expression: "displayPopup",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "br-10" },
            [
              _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "py-10 px-10 ta-c",
                      attrs: { row: "", wrap: "" },
                    },
                    [
                      !_vm.formValid
                        ? _c("v-flex", [
                            _c("label", { staticClass: "are-you-sure-lbl" }, [
                              _vm._v("Errors found"),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.formValid && !_vm.isEdit
                        ? _c("v-flex", [
                            _c("label", { staticClass: "are-you-sure-lbl" }, [
                              _vm._v("Create new EDI Tracking Link?"),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.formValid && _vm.isEdit
                        ? _c("v-flex", [
                            _c("label", { staticClass: "are-you-sure-lbl" }, [
                              _vm._v("Confirm the change"),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.emptyFields
                        ? _c("v-flex", { staticClass: "mt-6 ta-c" }, [
                            _c("label", { staticClass: "text-lbl" }, [
                              _vm._v(" The following fields "),
                              _c("b", [_vm._v("cannot be empty")]),
                              _vm._v(": " + _vm._s(_vm.emptyFields)),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.formValid
                        ? _c("v-flex", { staticClass: "mt-6 ta-c" }, [
                            _c("label", { staticClass: "text-lbl" }, [
                              _vm._v(
                                ' By clicking the "OK" button, the system will determine the tracking exchanges that will take place between the selected parties. Would you like to continue?'
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _c(
                        "v-row",
                        { staticClass: "ta-c w-100-pct" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "mt-8", attrs: { cols: "12" } },
                            [
                              _vm.formValid
                                ? _c("smart-btn", {
                                    staticClass: "mr-4",
                                    attrs: { type: "dismiss", label: "Cancel" },
                                    on: {
                                      click: function ($event) {
                                        _vm.displayPopup = false
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm.formValid
                                ? _c("smart-btn", {
                                    staticClass: "m0auto",
                                    attrs: {
                                      type: "primary",
                                      label: "OK",
                                      loading: _vm.saving,
                                    },
                                    on: { click: _vm.submitForm },
                                  })
                                : _vm._e(),
                              !_vm.formValid
                                ? _c("smart-btn", {
                                    staticClass: "m0auto",
                                    attrs: { type: "primary", label: "OK" },
                                    on: {
                                      click: function ($event) {
                                        _vm.displayPopup = false
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("smart-toast", {
                attrs: { display: _vm.snackbar, message: _vm.snackbarText },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("smart-toast", {
        attrs: {
          display: _vm.snackbarError,
          error: true,
          message: _vm.snackbarErrorText,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }